<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-row>
      <v-col cols="11">
        <h1 class="text-h5 mb-6">{{ $t('Customers') }}</h1>
      </v-col>
    </v-row>
    <customers-table include-search />
  </v-container>
</template>

<script>
import Vue from 'vue'
import CustomersTable from '@/components/customers/CustomersTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    CustomersTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Customers')
  })
}
</script>



// WEBPACK FOOTER //
// src/views/customers/Index.vue